import { inject, Service } from '@angular/core';
import { OnLoginComplete } from '@portal-core/auth/interfaces/login-complete.interface';
import { CoreService } from '@portal-client/core/core.service';

@Service()
export class LoginEventHandlerService implements OnLoginComplete {
  private readonly coreService = inject(CoreService);

  onLoginComplete() {
    this.coreService.checkAndShowGettingStartedDialog();
  }
}
